import styled, { css } from 'styled-components'

const Badge = styled.img`
  ${props =>
    !props.pdpV2 &&
    css`
      margin-right: 10px;
      margin-bottom: 5px;
    `}
  ${props =>
    props.pdpV2 &&
    css`
      @media (max-width: ${props.theme.size.breakpoint['max-width'].xs}) {
        max-height: 25px;
      }
    `}
`
const BadgeWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 5px 10px;
  ${props =>
    !props.pdpV2 &&
    css`
      margin-right: 10px;
    `}

  ${props =>
    props.pdpV2 &&
    css`
      @media (max-width: ${props.theme.size.breakpoint['max-width'].xs}) {
        svg {
          max-height: 25px;
          width: fit-content;
        }
      }
    `}
`

// eslint-disable-next-line import/prefer-default-export
export { Badge, BadgeWrapper }
